<template>
  <div class="qnr-intro-get-started card p-5 curved-border">
    <h1 class="title is-3 is-extra-bold">
      Get Started
    </h1>
    <div
      class="curved-border p-3 is-size-5 mb-6"
      :style="{borderColor: '#dfe2e7', borderWidth: '2px', fontWeight: 500}"
    >
      <div class="is-flex is-align-items-center mb-2">
        <i class="far fa-clock mr-3 base6Text " />
        <p>This will take 15 to 20 minutes</p>
      </div>
      <div class="is-flex is-align-items-center mb-2">
        <i class="fas fa-lock mr-3 redText" />
        <div>
          <p>Your answers will remain private</p>
          <p class="pl-2 is-size-7 has-text-weight-normal">
            Only you and {{ context.advisor_name }} will be able to see your answers
          </p>
        </div>
      </div>
      <div class="is-flex is-align-items-center mb-2">
        <i class="fas fa-save mr-3 base4Text " />
        <p>Your responses will be saved after each step.</p>
      </div>
    </div>
    <div class="is-size-7 has-text-grey bold mb-2">
      Your name
    </div>
    <b-input
      v-model="context.name"
      class="mb-2"
      disabled
    />
    <div class="is-size-7 has-text-grey bold mb-2">
      Your email address
    </div>
    <b-input
      type="email"
      maxlength="30"
      :value="context.prospect?.email"
      disabled
    />
    <router-link :to="{ name: 'institutional-qnr-section', params: { section: 1}, query: {advisor: context.advisor_slug, vuid: $route.query.vuid} }">
      <button class="button is-primary is-fullwidth is-size-4 curved-border heavy">
        Confirm details and start questionnaire
      </button>
    </router-link>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
import { mapStores } from 'pinia';

export default {
  name: 'QnrIntroGetStarted',
  components: { /* Subcomponents */ },
  props: ['context'],
  data() {
    return {
    };
  },
  computed: { 
    ...mapStores(useAdvisorStore),
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {
    const params = new URL(window.location.href).searchParams;
    this.advisorStore.vuid = params.get('vuid');
  },
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
